module.exports = {
    "small": 660,
    "medium": 768,
    "large": 1200,
    "menu": 1250,
    "x-large": 1390,
    "wide": 2100
}